
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1u7vh_145",
  "pad-bottom": "awsui_pad-bottom_15o6u_1u7vh_167",
  "virtual": "awsui_virtual_15o6u_1u7vh_171",
  "has-background": "awsui_has-background_15o6u_1u7vh_174",
  "highlighted": "awsui_highlighted_15o6u_1u7vh_177",
  "selected": "awsui_selected_15o6u_1u7vh_177",
  "disabled": "awsui_disabled_15o6u_1u7vh_195",
  "is-keyboard": "awsui_is-keyboard_15o6u_1u7vh_200",
  "visual-refresh": "awsui_visual-refresh_15o6u_1u7vh_203",
  "next-item-selected": "awsui_next-item-selected_15o6u_1u7vh_211",
  "parent": "awsui_parent_15o6u_1u7vh_236",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1u7vh_240",
  "child": "awsui_child_15o6u_1u7vh_256",
  "sticky": "awsui_sticky_15o6u_1u7vh_262",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_1u7vh_274",
  "after-header": "awsui_after-header_15o6u_1u7vh_280",
  "measure-strut": "awsui_measure-strut_15o6u_1u7vh_315",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_1u7vh_324",
  "screenreader-content": "awsui_screenreader-content_15o6u_1u7vh_328",
  "option-content": "awsui_option-content_15o6u_1u7vh_334",
  "select-all": "awsui_select-all_15o6u_1u7vh_338"
};
  